// extracted by mini-css-extract-plugin
export var text = "_z-0";